module.exports = __webpack_public_path__ + "img/activity5.57c84bff.jpg";